import { Box, Button, FormControl, InputLabel, MenuItem, Select, TextField } from '@mui/material'
import { FilterList } from '@mui/icons-material'
import { STATUS_OPTIONS, PRIORITY_OPTIONS } from './issues-constants'

export function IssueFilterBar({ filters, onChange, customers }) {
	const hasActiveFilters = filters.search || filters.status || filters.priority || filters.customer

	const set = (key) => (e) => onChange({ ...filters, [key]: e.target.value })

	const clearAll = () =>
		onChange({ search: '', status: '', priority: '', customer: '' })

	return (
		<Box display="flex" gap={2} flexWrap="wrap" alignItems="center" mb={3}>
			<TextField
				size="small"
				placeholder="Search issues…"
				value={filters.search}
				onChange={set('search')}
				sx={{ minWidth: 200 }}
			/>
			<FormControl size="small" sx={{ minWidth: 140 }}>
				<InputLabel>Status</InputLabel>
				<Select value={filters.status} label="Status" onChange={set('status')}>
					<MenuItem value="">All</MenuItem>
					{STATUS_OPTIONS.map((s) => (
						<MenuItem key={s} value={s}>
							{s.replace('_', ' ')}
						</MenuItem>
					))}
				</Select>
			</FormControl>
			<FormControl size="small" sx={{ minWidth: 140 }}>
				<InputLabel>Priority</InputLabel>
				<Select value={filters.priority} label="Priority" onChange={set('priority')}>
					<MenuItem value="">All</MenuItem>
					{PRIORITY_OPTIONS.map((p) => (
						<MenuItem key={p} value={p}>
							{p}
						</MenuItem>
					))}
				</Select>
			</FormControl>
			{customers && (
				<FormControl size="small" sx={{ minWidth: 180 }}>
					<InputLabel>Customer</InputLabel>
					<Select value={filters.customer} label="Customer" onChange={set('customer')}>
						<MenuItem value="">All</MenuItem>
						{customers.map((c) => (
							<MenuItem key={c} value={c}>
								{c}
							</MenuItem>
						))}
					</Select>
				</FormControl>
			)}
			{hasActiveFilters && (
				<Button
					size="small"
					variant="outlined"
					color="inherit"
					startIcon={<FilterList />}
					onClick={clearAll}
				>
					Clear filters
				</Button>
			)}
		</Box>
	)
}
